import { useState } from 'react'

import {
  Container,
  Grid,
  makeStyles,
  Box,
  Button,
  Typography,
  Divider,
  TextField,
  Chip,
} from '@material-ui/core'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import { ContentHeader, Page } from 'components'
// import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'

import styles from './styles'
// import * as service from 'service'

const useStyles = makeStyles(styles)

const AccountsShow = () => {
  const classes = useStyles()
  const snackbar = useSnackbar()

  const [open, setOpen] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  // const { response } = useFetch(service.intermediador.priceTables.get, {
  //   perPage: 10000,
  //   status: 'ACTIVE',
  // })

  const approve = () => {
    snackbar.open({
      variant: 'success',
      message: 'message',
    })
  }

  const reprove = () => {
    handleClickOpen()
    snackbar.open({
      variant: 'error',
      message: 'message',
    })
  }

  return (
    <Page title="Cliente">
      <Container maxWidth={false} className={classes.rootNew}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <ContentHeader
              menu="Clientes"
              title="visualizar"
              subtitle="Cliente"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box display="flex" direction="row">
              <Box mr={2}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={approve}
                >
                  Aprovar
                </Button>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  color="warning"
                  size="small"
                  onClick={reprove}
                >
                  Reprovar
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography color="textPrimary" variant="h6">
              Dados pessoais
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Nome
            </Typography>
            <Typography color="textPrimary" variant="body1">
              Eduardo
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              CPF/CNPJ
            </Typography>
            <Typography color="textPrimary" variant="body1">
              844.473.300-83
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Nome Fantasia
            </Typography>
            <Typography color="textPrimary" variant="body1">
              XPTO X
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Razão Social
            </Typography>
            <Typography color="textPrimary" variant="body1">
              XPTO X LTDA
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              E-mail
            </Typography>
            <Typography color="textPrimary" variant="body1">
              XCPTO@email.com
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Status
            </Typography>
            <Chip label="Pendente" size="small" />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography color="textPrimary" variant="h6">
              Localização
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              CEP
            </Typography>
            <Typography color="textPrimary" variant="body1">
              85950-000
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Estado
            </Typography>
            <Typography color="textPrimary" variant="body1">
              Paraná
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Cidade
            </Typography>
            <Typography color="textPrimary" variant="body1">
              Curitiba
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Bairro
            </Typography>
            <Typography color="textPrimary" variant="body1">
              Azul
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Rua
            </Typography>
            <Typography color="textPrimary" variant="body1">
              Zona sul
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Número
            </Typography>
            <Typography color="textPrimary" variant="body1">
              23
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Reprovar conta</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Escreva o motivo da reprova para registros.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Motivo da reprova"
            type="text"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleClose} color="primary">
            Reprovar
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  )
}

export default AccountsShow
